/* tslint:disable */

/**
 */
export class Packing {
    ID_PACKING?: number;
    ID_SHAPE?: number;
    ID_STUDY?: number;
    NOMEMBMAT?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/packing.ts